import React from 'react';
export function PageBannerIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M17 16H7v3h10v-3z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.537 6.444A2 2 0 0121 7.724V23H3V1h12.064a2 2 0 011.536.72l3.937 4.724zM5 21h14V8h-4V3H5v18z"
  }));
}